import { BaseReader } from "../base-reader";
import { PortfolioChartRequestArgs, PortfolioChartSchema } from "./portfolio-chart.types";

export class PortfolioChartReader extends BaseReader {
  /**
   * Get the portfolio chart for a given user
   * @param subAddr The subaccount address to get the account overview for
   * @returns The account overview for the given subaccount address
   */
  async getByAddr({ subAddr, range, type, fetchOptions }: PortfolioChartRequestArgs) {
    const response = await this.getRequest({
      schema: PortfolioChartSchema,
      url: `${this.deps.config.tradingHttpUrl}/api/v1/portfolio_chart`,
      queryParams: { account: subAddr, range, data_type: type },
      options: fetchOptions,
    });

    return response.data;
  }
}
